import React from 'react'

import { AppRoutes } from './Routes'

export default function App() {
    return <AppRoutes />

}
